@if (isEmbedded) {
  <div class="app-embedded" id="app">
    <section class="view-content" id="viewContent">
      <router-outlet />
    </section>
    @if (spinnerService.isLoading()) {
      <sas-spinner />
    }
  </div>
}
@else {
  <a class="d-flex align-items-center justify-content-center position-absolute cursor-pointer skip-to-content-link"
    tabindex="0"
    (click)="skipToContent()"
    (keydown)="skipToContent($event)">
    Skip to main content
  </a>
  <div class="app d-grid min-vh-100" id="app" [class.collapsed]="menuService.collapsed()" [class.menu-hidden]="menuService.hidden()">
    <!-- Mobile backdrop: closes drawer on tap -->
    <div aria-hidden="true"
        class="mobile-backdrop"
        [class.visible]="menuService.mobileOpen()"
        (click)="menuService.closeMobile()">
    </div>
    <sas-menu />
    <main #mainContent class="main d-flex flex-column">
      <sas-header>
        <ng-content select="[headerActions]" ngProjectAs="[headerActions]" />
      </sas-header>
      @if(!hideBreadcrumb()) {
      <sas-breadcrumb />
      }
      <section #viewContent class="view-content" id="viewContent" tabindex="-1">
        <router-outlet />
      </section>
    </main>
    @if (spinnerService.isLoading()) {
      <sas-spinner />
    }
  </div>
}
